import { useCookie } from '@/@core/composable/useCookie'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { sha256 } from 'js-sha256'
import { router } from '@/plugins/1.router/index.js'

export const useAuthStore = defineStore('authentication', () => {

  const errors = ref({
    username: undefined,
    password: undefined,
  })


  const ability = useAbility()

  const reLogin = async () => {
    let userData = useCookie('userData').value
    let hashedPassword = getStoredHashedPassword()
    login(userData.username, '', hashedPassword)
  }

  const login = async (username, password, hashedPassword = '') => {
    hashedPassword = hashedPassword == '' ? hashPassword(password) : hashedPassword
    try {
      const res = await $api('/auth/login', {
        method: 'POST',
        body: {
          username: username,
          password: hashedPassword,
        },
        onResponseError({ response }) {
          // console.log(response)
          errors.value.username = response._data.username
          errors.value.password = response._data.password

          return null
        },
      })

      storeHashedPassword(hashedPassword)

      const { result, accessToken, userData, userAbilityRules } = res

      // console.log(res)
      if (result === true) {
        useCookie('userAbilityRules').value = userAbilityRules
        ability.update(userAbilityRules)
        useCookie('userData').value = userData
        console.log('userData', userData)
        useCookie('accessToken').value = accessToken

        if (!useCookie('clientId').value)
          useCookie('clientId').value = generateUUID()
      }

      return result
    } catch (err) {
      console.error(err)

      return null
    }

    return false
  }

  const logout = () => {
    useCookie('userAbilityRules').value = null
    useCookie('userData').value = null
    useCookie('accessToken').value = null
    useCookie('clientId').value = null
    ability.update([])
  }

  const getCurrentUser = () => {
    return useCookie('userData').value
  }

  const hashPassword = password => {
    return sha256(password)
  }

  const storeHashedPassword = hashedPassword => {
    localStorage.setItem('hashedPassword', hashedPassword)
  }

  const getStoredHashedPassword = () => {
    return localStorage.getItem('hashedPassword')
  }

  const generateUUID = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID()
    }

    // Fallback for non-secure contexts or older browsers

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)

      return v.toString(16)
    })
  }

  const isTokenExpired = token => {
    if (!token) return true

    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      const currentTime = Math.floor(Date.now() / 1000)

      return payload.exp < currentTime
    } catch (error) {
      return true // If we can't parse the token, consider it expired
    }
  }

  const getAccessToken = () => {
    return useCookie('accessToken').value
  }

  const routToLoginPageIfTokenExpired = () => {
    if (isTokenExpired(getAccessToken())) {
      logout()
      router.push({ name: 'login' })
    }
  }

  return {
    login,
    reLogin,
    logout,
    getCurrentUser,
    hashPassword,
    storeHashedPassword,
    getStoredHashedPassword,
    isTokenExpired,
    getAccessToken,
    routToLoginPageIfTokenExpired,
  }
})
